import axios from 'axios';

/**
 * Requests a presigned S3 upload URL from the backend
 *
 * @param {Object} params
 * @param {string} params.contentType - MIME type (e.g., 'image/jpeg')
 * @param {string} params.fileName - Original filename
 * @returns Promise<Object> { url: string, key: string }
 */
export const requestUploadUrl = async ({ contentType, fileName }) => {
  const res = await axios.post('/media/images/request-upload-url', {
    contentType,
    fileName
  });

  // returns the URL that the browser can use to PUT/POST an image to S3
  // and the key (name) of the S3 asset, which is needed to later process
  // the image by OCR (needed to generate a pre-signed download URL)
  // { url: string, key: string }
  return res.data;
};
